// external imports
import React from 'react'
import Helmet from 'react-helmet'
import { FlexRow, FlexColumn } from 'quark-web'
import { graphql } from 'react-relay'
import { Route, Switch } from 'react-router-dom'
// local imports
import styles from './styles'
import ProductSummary from './ProductSummary'
import ProductSelector from './ProductSelector'
import { Text, Header, QueryRenderer } from '~/components'
import './../basicResponsive.css'

// return the node with a matching name
const findNode = (collection, name) =>
    collection.edges.find(({ node }) => node.name.toLowerCase() === decodeURI(name).toLowerCase()).node

const Products = () => (
    <React.Fragment>
        <Helmet title="Products" />
        <QueryRenderer
            query={graphql`
                query ProductsQuery {
                    allCategories {
                        edges {
                            node {
                                name
                                products {
                                    edges {
                                        node {
                                            name
                                            ...ProductSummary_product
                                        }
                                    }
                                }
                                family {
                                    name
                                }
                            }
                        }
                    }
                }
            `}
            render={data => {
                return (
                    data && (
                        <FlexRow style={styles.container}>
                            <Route path="/products/:familyName/:categoryName?/:productName">
                                {({ match }) => {
                                    // start off not showing a product
                                    let product = null
                                    let familyName, productName, categoryName

                                    // the selector needs to nest categories within their familes and categories without families at the top
                                    const selection = data.allCategories.edges.reduce((prev, { node: category }) => {
                                        // the products associated with this category
                                        const products = category.products.edges.map(({ node }) => node)
                                        // if the category has a family
                                        if (category.family) {
                                            // then we have to add the category and its products under the family
                                            return {
                                                ...prev,
                                                [category.family.name]: {
                                                    name: category.family.name,
                                                    categories: [
                                                        ...(prev[category.family.name] || { categories: [] })
                                                            .categories,
                                                        { name: category.name, products }
                                                    ]
                                                }
                                            }
                                        }
                                        // otherwise the category should be considered like a family
                                        return {
                                            ...prev,
                                            [category.name]: { name: category.name, products }
                                        }
                                    }, {})

                                    // if we matched the url
                                    if (match) {
                                        // grab the match params out of the result
                                        familyName = match.params.familyName
                                        categoryName = match.params.categoryName
                                        productName = match.params.productName

                                        // the list of products associated with the selection
                                        let products
                                        // if we are looking for a category within a family
                                        if (categoryName) {
                                            products = selection[familyName].categories.find(
                                                ({ name }) => name === categoryName
                                            ).products
                                        } else {
                                            products = selection[familyName].products
                                        }

                                        product = products.find(({ name }) => name === productName)
                                    }
                                    return (
                                        <React.Fragment>
                                            <ProductSelector
                                                currentProduct={productName}
                                                currentFamily={familyName}
                                                currentCategory={categoryName}
                                                selection={selection}
                                            />
                                            <ProductSummary product={product} />
                                        </React.Fragment>
                                    )
                                }}
                            </Route>
                        </FlexRow>
                    )
                )
            }}
        />
    </React.Fragment>
)

const offlineProducts = () => (
    <div style = {styles.container}>
        <Helmet title="Products" />

        <FlexColumn
         justifyContent="center"
         style={styles.column}>
            <Header style={styles.header}>Products</Header>
            <div className={'content'}>
                <Text>
                    Lark Seeds International supports several breeding programs in cucurbits and
                    solanum.{"\n\n"}

                    We develop our product line by working closely with customers to understand the
                    needs of local markets. Each product is aimed at specific market demands that
                    vary from environmental conditions to consumer needs.{"\n\n"}

                    With over one hundred and thirty varieties currently on the market spanning across 
                    ten vegetable families, we are confident Lark Seeds International's extensive
                    portfolio has what you are looking for.
                </Text>
            </div>
        </FlexColumn>
    </div>
)


export default offlineProducts



// WEBPACK FOOTER //
// ./src/views/Products/index.js